export default function TheComeback() {
  return (
    <section className="relative py-32 px-8 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f2bd614c05c5c5cc90a5c518395681fb.jpg"
          alt="The Comeback"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1000px] mx-auto text-center">
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-6 py-2 mb-8">
          <span className="text-xs font-bold text-white tracking-wide">THE NEXT CHAPTER</span>
        </div>

        <h2 className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-[0.9] tracking-tight mb-8">
          THE<br />
          COMEBACK<br />
          <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">STARTS NOW</span>
        </h2>

        <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed mb-12">
          <p>
            <strong className="text-white font-bold">BillPlay is entering a new era.</strong> Stronger. Sharper. More focused than ever.
          </p>
          
          <p>
            We're expanding our reach online, bringing our culture to a nationwide audience while staying rooted in the community that built us.
          </p>

          <p className="text-white font-bold text-2xl">
            This isn't a relaunch. It's a resurgence.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#next-drop" 
            className="bg-white text-black px-10 py-4 rounded-lg font-black text-sm hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            JOIN THE NEXT DROP
          </a>
        </div>
      </div>
    </section>
  );
}